<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <div>
        <a-input-search
          v-model:value="keyword"
          enter-button
          class="w300"
          placeholder="请输入材料名称关键字"
          @search="search"
        ></a-input-search>
      </div>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>
    <div class="label-wrap__line">
      限定：
      <a-tag color="#F8982F" v-if="firstData && firstData.repertotyName">
        {{ firstData?.repertotyName }}
      </a-tag>
      <a-tag color="#F8982F" v-if="companyId && firstData && firstData.repertotyName">
        {{ firstData?.supplierName }}
      </a-tag>
    </div>

    <!-- <a-table
      row-key="storageId"
      size="small"
      :bordered="true"
      :loading="loading"
      :data-source="data"
      :columns="columns"
      :scroll="{ x: true, y: tableHeight + 'px' }"
      :pagination="pagination"
      :row-selection="{
        selectedRowKeys: selectedIds,
        onChange: onSelectionChange,
        fixed: true,
      }"
      @change="onTableChange"
    >
      <template #index="{ index }">{{ index + 1 }}</template>
      <template #taxPrice="{ record }">
        {{ $filters.formatMoney(record.taxPrice) }}
      </template>
      <template #expandedRowRender="{ record }">
        <p style="margin: 0; display: flex; align-items: center">
          {{
            `规格型号：${record.materialModel} | 品牌：${record.materialBrand} | 结算单位：${record.materialUnit} | 关联PO单：${record.purchaseOrderNo} | 所属项目：${record.projectName}`
          }}
        </p>
      </template>
    </a-table> -->
    <table-wrapper
      row-key="storageId"
      size="small"
      :border="true"
      ref="tableRef"
      :data-source="data"
      :columns="columns"
      @onSelectionChange="onSelectionChange"
      :pagination="pagination"
      :tableHeight="tableHeight"
      @onTableChange="onTableChange"
      :loading="loading"
      :data-config="{ format: dataFormat }"
      >
      <!-- :expandSlot="'expandedRowRender'" -->
      <template #taxPrice="{ record }">
        {{ $filters.formatMoney(record.taxPrice) }}
      </template>
      <!-- <template #expandedRowRender="{ record }">
        <p style="margin: 0; display: flex; align-items: center">
          {{
            `规格型号：${record.materialModel} | 品牌：${record.materialBrand} | 结算单位：${record.materialUnit} | 关联PO单：${record.purchaseOrderNo} | 所属项目：${record.projectName}`
          }}
        </p>
      </template> -->
    </table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, computed, PropType } from "vue";
import { StoreMaterialService } from "../store-material-service";
import { StoreMaterialListRecord, StoreMaterialPageReq } from "../store-material-interface";
import { columns } from "./constant";

export default defineComponent({
  name: "MaterialTable",
  props: {
    repoId: { type: String, default: "" },
    companyId: { type: String, default: "" },
    tableHeight: {
      type: Number,
      default: 0,
    },
    value: { type: Array as PropType<StoreMaterialListRecord[]>, default: [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: StoreMaterialListRecord[];
      selectedList: any[];
      columns: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns: columns,
    });

    const queryReq = new StoreMaterialPageReq(props.repoId, props.companyId);
    const queryRef = reactive(queryReq);

    const firstData = computed(() => {
      return data.value[0];
    });

    const { data, loading, run, pagination } = StoreMaterialService.usePageApi();

    const search = async () => {
      queryRef.current = 1;
      queryRef.materialName = state.keyword;
      (queryRef as any).filterCountNonZeroFlag = 1;
      await run(queryRef);
    };
    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      (queryRef as any).filterCountNonZeroFlag = 1;
      await run(queryRef);
    };

    const onSelectionChange = ({ ids, selectedRows }) => {
      state.selectedIds = ids;
      state.selectedRows = selectedRows;
    };

    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "storageId"));
    };
    const dataFormat = (rows) => {
      let ids = rows.reduce((pre, cur) => {
        pre.push(cur.storageId);
        return pre;
      }, []);
      return {
        ids,
        selectedRows: rows,
      };
    };

    onMounted(async () => {
      (queryRef as any).filterCountNonZeroFlag = 1;
      await run(queryReq);
    });

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.storageId);
        state.selectedIds = ids;
      },
      { immediate: true }
    );

    return {
      ...toRefs(state),
      loading,
      data,
      pagination,
      search,
      onSelectionChange,
      add,
      onTableChange,
      firstData,
      dataFormat,
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
.label-wrap__line {
  height: 40px;
  display: flex;
  align-items: center;
  background-color: rgba(255, 251, 230, 1);
  margin-bottom: 10px;
  padding-left: 20px;
}
</style>
